import { useEffect, useMemo, useRef, useState } from "react";

import { Box, Button, Card, Checkbox, Chip, Collapse, Fade, Grid, IconButton, Stack, TextField, Typography } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import ClearIcon from "@mui/icons-material/Clear";

import { DESTINATION, LAYOUT_MARGIN, SOURCE } from "Configs/home";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";
import useCameras from "Hooks/useCamera";
import { selectCamera } from "Redux/cameraSlice";
import { createTrafficAnalysisStarUrl } from "Redux/starSlice";

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 8,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContent: 56,
  bottomContentMargin: 16,
};

export default function Cameras() {
  const dispatch = useAppDispatch();
  const { visible, selectedCamera } = useAppSelector((state) => state.camera);

  const { height } = useWindowSize();

  const [isOpen, setIsOpen] = useState<boolean>(true);
  const [cameraName, setCameraName] = useState<string>("");

  const toggleCollapse = () => setIsOpen((prev) => !prev);

  const sideRef = useRef<HTMLDivElement>(null);

  const boxHeight = useMemo(() => {
    let result = 0;
    Object.keys(SIZES).forEach((key) => {
      result += SIZES[key];
    });
    return `${height - (result + LAYOUT_MARGIN * 2)}px`;
  }, [height]);

  const { data } = useCameras();

  const handleClick = (cam: any) => {
    if (selectedCamera[0]?.DeviceCode === cam.DeviceCode) {
      dispatch(
        createTrafficAnalysisStarUrl([
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=25c862a7-9341-454d-b113-10c77f41d1c6&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=e6543d83-0368-4915-93c6-175e6998ed78&paramvalues={"a9a44bc5-249d-abd1-278e-5ab194462f4f":[{"Value":[],"FromColumn":false,"SelectedField":null}]}`,
        ])
      );
      dispatch(selectCamera([]));
    } else {
      dispatch(
        createTrafficAnalysisStarUrl([
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=54c0cd88-12de-4c51-8685-c44b92b737d6&paramvalues={"6fdfaf88-4f4a-cc25-ecaf-2da853c48f65":[{"Value":{"Id":"${cam?.DeviceCode}","Value":${cam?.DeviceCode},"DisplayValue":${cam?.DeviceCode}},"FromColumn":false,"SelectedField":null}]}`,
          `https://report.baarestan.ir:8080/dashboard/publicview?dashboardid=e2ffa658-2244-4b16-99d4-2f5e11e39bfb&paramvalues={"6fdfaf88-4f4a-cc25-ecaf-2da853c48f65":[{"Value":{"Id":${cam?.DeviceCode},"Value":${cam?.DeviceCode},"DisplayValue":${cam?.DeviceCode}},"FromColumn":false,"SelectedField":null}]}`,
        ])
      );
      dispatch(selectCamera([cam]));
    }
  };

  const renderAllCameras = useMemo(() => {
    return (
      <>
        {data?.map((item: any) => {
          if (!item.dev) return;
          const camera = JSON.parse(`{${item.dev}}`);

          // This code is for search by name
          if (camera.DeviceName.indexOf(cameraName) === -1) return;
          //
          return (
            <Stack direction="row">
              <Button
                sx={{
                  border: "1px solid #aaa",
                  p: 1,
                  borderRadius: 1,
                  width: "90%",
                  marginBottom: "15px",
                  justifyContent: "flex-start",
                  backgroundColor: camera?.DeviceCode === selectedCamera[0]?.DeviceCode ? "red" : "",
                }}
                onClick={() => handleClick(camera)}
              >
                <Stack sx={{ width: "100%" }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    {camera.DeviceName}
                  </Grid>
                </Stack>
              </Button>
              <Checkbox
                inputProps={{ "aria-label": "Checkbox demo" }}
                sx={{
                  "&:hover": { bgcolor: "transparent" },
                }}
              />
            </Stack>
          );
        })}
      </>
    );
  }, [data, cameraName]);

  const renderSelectedCamera = useMemo(() => {
    return (
      <>
        {selectedCamera?.map((camera: any) => {
          return (
            <Stack direction="row">
              <Button
                sx={{
                  border: "1px solid #aaa",
                  p: 1,
                  borderRadius: 1,
                  width: "90%",
                  marginBottom: "15px",
                  justifyContent: "flex-start",
                  backgroundColor: camera?.DeviceCode === selectedCamera[0]?.DeviceCode ? "rgb(0 160 128 / 20%)" : "",
                }}
                onClick={() => handleClick(camera)}
              >
                <Stack sx={{ width: "100%" }}>
                  <Grid container justifyContent="space-between" alignItems="center">
                    {camera.DeviceName}
                  </Grid>
                </Stack>
                <ClearIcon sx={{ color: "red" }} />
              </Button>
              <Checkbox
                inputProps={{ "aria-label": "Checkbox demo" }}
                sx={{
                  "&:hover": { bgcolor: "transparent" },
                }}
              />
            </Stack>
          );
        })}
      </>
    );
  }, [selectedCamera]);

  return (
    <Fade in={visible} mountOnEnter unmountOnExit>
      <Card sx={{ mt: 1, p: 2, width: "100%", boxShadow: 3 }}>
        <Stack direction="row" justifyContent="space-between" alignItems="center">
          <Typography fontWeight="800">لیست سیستم ها </Typography>
          <Button
            startIcon={<KeyboardDoubleArrowDownIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "all 0.3s" }} />}
            sx={{ minWidth: "100px" }}
            onClick={toggleCollapse}
          >
            {isOpen ? "بستن" : "بازکردن"}
          </Button>
        </Stack>

        <Collapse in={isOpen}>
          <TextField
            id="camera-search"
            label="جستجو"
            variant="outlined"
            sx={{ width: "87%" }}
            value={cameraName}
            onChange={(e) => setCameraName(e.target.value)}
          />
          <Box sx={{ height: boxHeight, py: 2, overflowY: "scroll" }} ref={sideRef}>
            {selectedCamera?.length > 0 ? renderSelectedCamera : renderAllCameras}
          </Box>
        </Collapse>
      </Card>
    </Fade>
  );
}
